import { render, staticRenderFns } from "./AutoAvaliacao.vue?vue&type=template&id=95329160&scoped=true"
import script from "./AutoAvaliacao.vue?vue&type=script&lang=js"
export * from "./AutoAvaliacao.vue?vue&type=script&lang=js"
import style0 from "./AutoAvaliacao.vue?vue&type=style&index=0&id=95329160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95329160",
  null
  
)

export default component.exports